$(function () {
    $('[data-smoothscroll]').on('click', function (event) {
        event.preventDefault();
        window.scrollTo('#' + $(this).data('smoothscroll'));
    });
    $(window).on('load', function () {
        if (window.location.hash) {
            window.scrollTo(window.location.hash);
        }
    });
});

window.scrollTo = function (targetName) {
    const target = $(targetName);

    if (!target.length) {
        console.log('Smoothscroll kan de volgende module niet vinden:', targetName);
        return;
    }

    let offset = target.offset().top;

    offset -= $('.header').outerHeight();

    $('html, body').animate({
        scrollTop: offset,
    }, 1000);
};

$('a[href^="#"').on('click', function (e) {
    let href = $(this).attr('href');
    let target = $(document.getElementById(href.replace('#', '')));
    if (!target.length) {
        return;
    }
    e.preventDefault();

    let offset = $('.header').outerHeight();
    let extraoffset = 16; // 1 rem extra offset
    let paddingmarginoffset = 0; // we willen geen rekening houden met evt. padding / margin van een element, element.offset().top doet dat wel en dat willen we juist niet.
    paddingmarginoffset += target.outerHeight(true) - target.outerHeight(); // margin top&bot
    paddingmarginoffset += target.innerHeight() - target.height(); // padding top&bot
    paddingmarginoffset += target.outerHeight() - target.innerHeight(); // border top&bot
    paddingmarginoffset /= 2; // van top&bot naar alleen top

    $('html, body').animate({
        scrollTop: target.offset().top - offset - extraoffset + paddingmarginoffset,
    }, 1000);
});
